export default {
    start({commit, state, rootState}) {
        if (rootState.type == 'web-engagement') {
            if (rootState.init_auth == 'sign_up' && rootState.signup == true) {
                commit('SET_ACTIVE', 'websignup')
            } else {
                commit('SET_ACTIVE', 'websignin')
            }
        } else {
            let member = rootState.members.find(m => m.active == true)
            if (member.security == 'LOW' && member.phone && member.phone.number && member.phone.code) {
                commit('SET_ACTIVE', 'phone')
            }
            if (member.security == 'LOW' && (!member.phone || !member.phone.number || !member.phone.code)) {
                commit('SET_ACTIVE', 'pin')
            }
            if (member.security == 'HIGH') {
                commit('SET_ACTIVE', 'signin')
            }
        }
    },
    cancel({commit, state, rootState}) {
        let member = rootState.members.find(m => m.active == true)
        if (state.authenticated == true && rootState.members.length > 1) {
            if (rootState.member_original) {
                let o = rootState.member_original
                commit('SET_MEMBERS', rootState.members.map(m => {
                    m.active = m.email == o.email;
                    return m
                }), {root: true})
                commit('SET_ORIGINAL_MEMBER', null, {root: true})
            } else {
                commit('SET_MEMBERS', rootState.members.map(m => {
                    m.active = !m.active;
                    return m
                }), {root: true})
            }
        } else {
            commit('SET_AUTHENTICATED', false)
        }
        commit('SET_ACTIVE', null)
        commit('SET_RESPONSE', null)
    },
    webidentify({commit, state, rootState}, payload) {
        commit('SET_RESPONSE', null)
        payload.id = rootState.id
        return axios.post('/e/webidentify', payload).then(response => {
            return {label: response.data.label, method: response.data.method}
        }).catch(error => {
            let message = parseError(error)
            if (error.response.status === 403) {
                commit('SET_RESPONSE', {
                    title: 'error.phone',
                    description: 'phone_help',
                    class: 'alert-danger'
                })
                return false
            }
            if (error.response.status === 423) {
                commit('SET_RESPONSE', {
                    title: 'blocked.title',
                    description: 'blocked.description',
                    class: 'alert-danger'
                })
                return false
            }
            commit('SET_RESPONSE', {
                title: 'error.email',
                description: null,
                class: 'alert-danger'
            })
            return false
        })
    },
    webpin({commit, state, rootState}, payload) {
        commit('SET_RESPONSE', null)
        payload.id = rootState.id
        return axios.post('/e/webpin', payload).then(response => {
            return true
        }).catch(error => {
            let message = parseError(error)
            if (error.response.status === 423) {
                commit('SET_RESPONSE', {
                    title: 'blocked.title',
                    description: 'blocked.description',
                    class: 'alert-danger'
                })
                return false
            }
            commit('SET_RESPONSE', {
                title: 'error.title',
                description: 'error.description',
                class: 'alert-danger'
            })
            return false
        })
    },
    webverify({commit, state, rootState}, payload) {
        commit('SET_RESPONSE', null)
        payload.id = rootState.id
        return axios.post('/e/webverify', payload).then(response => {
            if (response.data && response.data.id && response.data.member) {
                commit('SET_ID', response.data.id, {root: true})
                commit('ADD_MEMBER', response.data.member, {root: true})
                commit('SET_AUTHENTICATED', true)
                if (response.data.hasOwnProperty('session')) {
                    commit('SET_SESSION', response.data.session, {root: true})
                }
                return true
            }

            return null
        }).catch(error => {
            let message = parseError(error)
            if (error.response.status === 423) {
                commit('SET_RESPONSE', {
                    title: 'blocked.title',
                    description: 'blocked.description',
                    class: 'alert-danger'
                })
                return false
            }
            commit('SET_RESPONSE', {
                title: 'auth.pin_error',
                description: 'auth.pin_help',
                class: 'alert-danger'
            })
            return false
        })
    },
    websignin({commit, state, rootState}, payload) {
        payload.id = rootState.id
        return axios.post('/e/websignin', payload).then(response => {
            commit('SET_ID', response.data.id, {root: true})
            commit('ADD_MEMBER', response.data.member, {root: true})
            commit('SET_AUTHENTICATED', true)
            if (response.data.hasOwnProperty('session')) {
                commit('SET_SESSION', response.data.session, {root: true})
            }
            return true
        }).catch(error => {
            let message = parseError(error)
            if (error.response.status === 423) {
                commit('SET_RESPONSE', {
                    title: 'blocked.title',
                    description: 'blocked.description',
                    class: 'alert-danger'
                })
                return false
            }
            commit('SET_RESPONSE', {title: 'auth.password_error', description: null, class: 'alert-danger'})
            return false
        })
    },
    websignup({commit, state, rootState}, payload) {
        payload.id = rootState.id
        return axios.post('/e/websignup', payload).then(response => {
            commit('SET_ID', response.data.id, {root: true})
            commit('ADD_MEMBER', response.data.member, {root: true})
            commit('SET_AUTHENTICATED', true)
            if (response.data.hasOwnProperty('session')) {
                commit('SET_SESSION', response.data.session, {root: true})
            }
            return true
        }).catch(error => {
            let message = parseError(error)
            if (error.response.status === 422 && error.response.data === 'EMAIL_EXISTS') {
                commit('SET_RESPONSE', {title: 'auth.email_error', description: null, class: 'alert-danger'})
                return false
            }
            if (error.response.status === 423) {
                commit('SET_RESPONSE', {
                    title: 'blocked.title',
                    description: 'blocked.description',
                    class: 'alert-danger'
                })
                return false
            }
            commit('SET_RESPONSE', {title: 'auth.signup_error', description: null, class: 'alert-danger'})
            return false
        })
    },
    webpassword({commit, state, rootState}, payload) {
        payload.id = rootState.id
        return axios.post('/e/auth/password', payload).then(response => {
            if (response && response.data && response.data.member) {
                commit('SET_ID', response.data.id, {root: true})
                commit('ADD_MEMBER', response.data.member, {root: true})
                commit('SET_AUTHENTICATED', true)
                if (response.data.hasOwnProperty('session')) {
                    commit('SET_SESSION', response.data.session, {root: true})
                }
                return true
            }
        }).catch(error => {
            let message = parseError(error)
            if (error.response.status === 423) {
                commit('SET_RESPONSE', {
                    title: 'blocked.title',
                    description: 'blocked.description',
                    class: 'alert-danger'
                })
                return false
            }
            commit('SET_RESPONSE', {
                title: 'error.title',
                description: 'error.description',
                class: 'alert-danger'
            })
            return false
        })
    },
    requestpin({commit, state, rootState}, payload) {
        return axios.post('/e/' + rootState.code + '/request', {action: 'reset'}).then(response => {
            return true
        }).catch(error => {
            let message = parseError(error)
            return false
        })
    },
    pin({commit, state, getters, rootState}, payload) {
        commit('SET_LOADING', true, {root: true})
        commit('SET_REQUEST', axios.CancelToken.source(), {root: true})
        payload.id = rootState.code
        payload.code = rootState.members.find(m => m.active == true).code
        payload.download = rootState.download
        return axios.post('/e/auth/pin', payload).then(response => {
            commit('SET_REQUEST', null, {root: true})
            commit('SET_LOADING', false, {root: true})
            return response.data
        }).catch(error => {
            let message = parseError(error)
            commit('SET_ERROR', message, {root: true})
            commit('SET_REQUEST', null, {root: true})
            commit('SET_LOADING', false, {root: true})

            let code = error && error.response && error.response.status ? error.response.status : -1
            if (code == 423) {
                return {
                    title: 'blocked.title',
                    description: 'blocked.description',
                    class: 'alert-danger'
                }
            }
            return {
                title: 'error.title',
                description: 'error.description',
                class: 'alert-danger'
            }
        })
    },
    signin({commit, state, getters, rootState}, payload) {
        commit('SET_LOADING', true, {root: true})
        commit('SET_REQUEST', axios.CancelToken.source(), {root: true})
        let member = rootState.members.find(m => m.active == true)
        payload.id = rootState.code
        payload.code = member.code
        payload.download = rootState.download
        return axios.post('/e/signin', payload).then(response => {
            commit('SET_REQUEST', null, {root: true})
            commit('SET_LOADING', false, {root: true})
            commit('SET_ID', response.data.id, {root: true})
            commit('ADD_MEMBER', {...member, ...response.data.member}, {root: true})
            commit('SET_AUTHENTICATED', true)
            return response.data
        }).catch(error => {
            let message = parseError(error)
            commit('SET_ERROR', message, {root: true})
            commit('SET_REQUEST', null, {root: true})
            commit('SET_LOADING', false, {root: true})

            let code = error && error.response && error.response.status ? error.response.status : -1
            if (code == 423) {
                return {
                    title: 'blocked.title',
                    description: 'blocked.description',
                    class: 'alert-danger'
                }
            }
            return {
                title: 'error.title',
                description: 'error.description',
                class: 'alert-danger'
            }
        })
    },
    otp({commit, state, getters, rootState}, payload) {
        commit('SET_LOADING', true, {root: true})
        commit('SET_REQUEST', axios.CancelToken.source(), {root: true})
        let member = rootState.members.find(m => m.active == true)
        payload.id = rootState.code
        payload.code = member.code
        payload.download = rootState.download
        payload.otp = rootState.otp
        return axios.post('/e/otp', payload).then(response => {
            commit('SET_REQUEST', null, {root: true})
            commit('SET_LOADING', false, {root: true})
            commit('SET_ID', response.data.id, {root: true})
            commit('ADD_MEMBER', {...member, ...response.data.member}, {root: true})
            commit('SET_AUTHENTICATED', true)
            return true
        }).catch(error => {
            console.error(error)
            commit('SET_REQUEST', null, {root: true})
            commit('SET_LOADING', false, {root: true})
            return false
        })
    },
    password({commit, state, getters, rootState}, payload) {
        commit('SET_LOADING', true, {root: true})
        commit('SET_REQUEST', axios.CancelToken.source(), {root: true})
        let member = rootState.members.find(m => m.active == true)
        payload.id = rootState.code
        payload.code = member.code
        payload.download = rootState.download
        return axios.post('/e/auth/password', payload).then(response => {
            commit('SET_REQUEST', null, {root: true})
            commit('SET_LOADING', false, {root: true})
            commit('ADD_MEMBER', {...member, ...response.data.member}, {root: true})
            commit('SET_AUTHENTICATED', true)
            return response.data
        }).catch(error => {
            let message = parseError(error)
            commit('SET_ERROR', message, {root: true})
            commit('SET_REQUEST', null, {root: true})
            commit('SET_LOADING', false, {root: true})

            let code = error && error.response && error.response.status ? error.response.status : -1
            if (code == 423) {
                return {
                    title: 'blocked.title',
                    description: 'blocked.description',
                    class: 'alert-danger'
                }
            }
            return {
                title: 'error.title',
                description: 'error.description',
                class: 'alert-danger'
            }
        })
    },
}
